import { queryClient } from '../components/react-query-provider-wrapper';

export const invalidateQueries: typeof queryClient.invalidateQueries = (
  ...args
) =>
  queryClient.invalidateQueries(
    ...(args as Parameters<typeof queryClient.invalidateQueries>),
  );

export const removeQueries: typeof queryClient.removeQueries = (...args) =>
  queryClient.removeQueries(
    ...(args as Parameters<typeof queryClient.removeQueries>),
  );

export const setQueriesData: typeof queryClient.setQueriesData = (...args) =>
  queryClient.setQueriesData(
    ...(args as Parameters<typeof queryClient.setQueriesData>),
  );
